import axios from 'axios'

export default {
  state: {
    users: [],
    filters: {},
    pagination: {},
  },
  mutations: {
    setUsers(state, payload) {
      state.users = payload
    },
    setUsersFilters(state, payload) {
      state.filters = payload
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
  },
  actions: {
    queryUsers({state, dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'users', {params: state.filters})
        .then(res => {
          commit('setUsers', res.data.data)
          commit('setPagination', {per_page: res.data.per_page, total: res.data.total, last_page: res.data.last_page})
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    storeUser({dispatch, commit}, formData) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'users', formData)
        .then(res => {
          dispatch('queryUsers')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    updateUser({dispatch, commit, rootGetters}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'users/' + payload[0], payload[1])
        .then(res => {
          if (rootGetters.getAuthUser.role === 'admin')
            dispatch('queryUsers')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
          if (payload[0] == rootGetters.getAuthUser.id)
            dispatch('queryAuth')
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    destroyUser({dispatch, commit}, user_id) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'users/' + user_id)
        .then(res => {
          dispatch('queryUsers')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
  },
  getters: {
    getUsers(state) {
      return state.users
    },
    getUsersPagination(state) {
      return state.pagination
    },
    getUsersOptions(state) {
      let options = []

      for (let user of state.users)
        options.push({id: user.id, label: user.name + ' ' + user.surname})

      return options
    }
  }
}